export default __webpack_public_path__ + "static/media/Graph_SMP-Low.5017176c.svg";